<template>
  <div class="h-100">
    <FrameMobile>
      <template v-slot:header>
        <GeneralHeaderMobile :headerBackground="headerBackground" :title="title" />
      </template>
      <template v-slot:content>
        <!-- ReturnList begin -->
        <ListContainer itemKey="returnRequestNo" :fetch="fetch" :emptyHint="emptyHint" :spinner="spinnerStyle" @initialized="onListInitialized">
          <template v-slot:list-header>
          </template>
          <template v-slot:list-item="{ item }">
            <div class="m-3 bg-white border border-light rounded-md" style="overflow: hidden;">
              <div class="d-flex align-items-center justify-content-between bg-gray100" @click="onToggle(item)">
                <div class="p-3 font-size-md">{{ $t('return.orderId') }} {{ item.orderId }}</div>
                <div>
                  <a class="px-2 text-gray600" href="javascript:void(0)">
                    <span class="material-icons">
                      <template v-if="item.isCollapsed">keyboard_arrow_up</template>
                      <template v-else>keyboard_arrow_down</template>
                    </span>
                  </a>
                </div>
              </div>
              <b-collapse :id="String(item.returnRequestNo)">
                <template v-if="item.isCollapsed">
                  <div class="d-flex align-items-center border-bottom border-light my-3 mx-2">
                    <ReturnRequestTimeline class="flex-column-reverse" :returnRequest="item" />
                  </div>
                  <ReturnRequestDetail class="mx-3" :returnRequest="item" />
                </template>
              </b-collapse>
            </div>
          </template>
        </ListContainer>
        <!-- ReturnList end -->
      </template>
      <template v-slot:footer>
        <FooterMobile :currentItem="currentFooterItem" />
      </template>
    </FrameMobile>
  </div>
</template>

<script>
import { forkJoin } from 'rxjs';

import GeneralHeaderMobile from '@/components/mcf/GeneralHeaderMobile.vue';
import FooterMobile from '@/components/FooterMobile.vue';
import FrameMobile from '@/components/mcf/FrameMobile.vue';
import ReturnRequestTimeline from '@/components/returnRequest/ReturnRequestTimeline.vue';
import ReturnRequestDetail from '@/components/returnRequest/ReturnRequestDetail.vue';
import ListContainer from '@/components/ListContainer.vue';

import pdiService from '@/services/pdiService';

import pageSettingGetter from '@/utils/pageSettingGetter';

export default {
  components: {
    GeneralHeaderMobile,
    FooterMobile,
    FrameMobile,
    ReturnRequestTimeline,
    ReturnRequestDetail,
    ListContainer,
  },
  data() {
    return {
      // 頁首背景圖
      headerBackground: '',
      // 讀取spinner樣式
      spinnerStyle: '',
      // 空白頁設定
      emptyHint: {},
      // 當前頁尾項目
      currentFooterItem: 'MemberCentreHomePage',
      // 頁面標題
      title: '',
    };
  },
  created() {
    const vm = this;

    vm.$store.dispatch('getPageSetting', 'ReturnRequest')
      .then((setting) => {
        // 頁面標題
        const title = pageSettingGetter.getFunctionWording(setting, 'TitleWording');
        document.title = title;
        vm.title = title;
        // 頁首背景圖
        vm.headerBackground = setting.backgroundMobilePic;
        // 取得頁面 style
        vm.spinnerStyle = setting.layoutType === '0' ? 'light' : 'secondary';
        // 空白頁設定
        vm.emptyHint.desc = pageSettingGetter.getFunctionWording(setting, 'BlankPageWording');
        vm.emptyHint.img = pageSettingGetter.getFunction(setting, 'BlankPagePic').picUrl;
      });
  },
  methods: {
    // 取得資料 observable
    fetch(pagination, filter) {
      const vm = this;
      const payload = { pagination, ...filter };
      return forkJoin({ list: vm.updateReturnRequestList(payload) });
    },
    // 列表初始化完成
    onListInitialized(data) {
      if (data[0]) {
        this.onToggle(data[0]);
      }
    },
    // 退貨申請展開/縮合
    onToggle(returnRequest) {
      const vm = this;
      returnRequest.isCollapsed = !returnRequest.isCollapsed;
      // 判斷是否已經載入商品資料
      if (returnRequest.isCollapsed && !returnRequest.hasLoaded) {
        const body = {
          companyId: vm.$store.state.companyId,
          productInfos: returnRequest.items.map((x) => ({
            productCode: x.productCode,
            subProductCode: x.subProductCode,
            productVer: x.productVer,
          })),
        };
        this.$subscribeTo(pdiService.getProducts(body), (res) => {
          returnRequest.items.forEach((item) => {
            const current = res.response.data.find((x) => x.productID === item.productId && x.productVer === item.productVer && x.spec.subProductCode === item.subProductCode);
            item.sPicture = current.sPicture;
            item.productName_CH = current.productName_CH;
            item.spec = current.spec;
          });

          returnRequest.hasLoaded = true;
        });
      }

      // toggle collapse
      vm.$root.$emit('bv::toggle::collapse', String(returnRequest.returnRequestNo));
    },
    // 更新退貨申請列表
    updateReturnRequestList(payload) {
      const vm = this;
      return vm.$store.dispatch('getReturnRequests', payload).then((res) => {
        if (res.response && res.response.data) {
          return res.response.data.map((x) => ({
            returnRequestNo: x.returnRequestNo,
            orderId: x.eRPOrderID,
            requestTime: x.returnRequestTime,
            currency: x.currency,
            totalPrice: x.amountIncF,
            discount: x.totalDiscount,
            shippingFee: x.shippingFee,
            items: x.productInfo.map((item) => ({
              productCode: item.productCode,
              subProductCode: item.subProductCode,
              productVer: item.productVer,
              productId: item.productID,
              price: item.price,
              subAmount: item.subAmount,
              subDiscount: item.subtotalDiscount,
              qty: item.qty,
              subtotalTax: item.subtotalTax,
              subtotal: item.subtotalPrice,
            })),
            isCollapsed: false,
            hasLoaded: false,
          }));
        }
        return [];
      });
    },
  },
};
</script>

<style scoped>
.nav-link{ padding: .5rem;}
/* .te-tabs-mcf .nav-tabs { color: rgba(255,255,255, .73);}
.nav-link.active a{ color: rgba(255,255,255,0.73);} */
.te-tabs-mcf .nav-tabs a {color: rgba(255,255,255,0.73);}
.nav-tabs .nav-link.active {color: rgba(255,255,255,1.0);}
.McfBgImg{ transform:scale(1.5); filter: brightness(.5) blur(4px); -webkit-filter: brightness(.5) blur(4px);}
/* tab default height */
.default-height {
  min-height: 60.67px;
}
</style>
